import { useState } from "react";

import {
  Button,
  Modal,
  TextArea,
  useModal,
  LoadingSpinner,
} from "@newsela/angelou";
import { objectTypes, actionNames } from "@newsela/snitch";

import { withTrackEvent } from "@newsela/snitch";
import useGuidedHighLightingTeacher from "@/view/utils/useGuidedHighLightingTeacher";

import useReportContent from "@/view/utils/useReportContent";
import {
  ButtonCss,
  footerButtonsWrapper,
  modalCss,
  modalFooterCss,
  modalTitle,
  modalWrapper,
  textAreaCss,
} from "./GuidedHighlightingTeacherFeedbackModal.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface IProps {
  isOpen: boolean;
  closeModal: () => void;
  contentId: string;
  setDisabled: () => void;
}

const GuidedHighlightingTeacherFeedbackModal = ({
  isOpen,
  closeModal,
  contentId,
  setDisabled,
}: IProps) => {
  const [modalProps] = useModal(true);
  const [isLoading, setIsLoading] = useState(false);
  const { handleQuestionFeedbackThumbsDown } = useGuidedHighLightingTeacher();
  const { handleCancelReport, handleTextAreaChange, problemDescription } =
    useReportContent();

  const dismissModal = () => {
    handleCancelReport();
    closeModal();
  };

  const handleSubmitButton = async () => {
    setIsLoading(true);
    await handleQuestionFeedbackThumbsDown(contentId);
    setIsLoading(false);
    setDisabled();
    closeModal();
  };

  return (
    <Modal
      {...modalProps}
      isActive={isOpen}
      onBackgroundClick={dismissModal}
      ariaProps={{
        "aria-labelledby": "teacher-guided-highlighting-card",
      }}
      __cssFor={{ root: modalCss }}
    >
      <div css={modalWrapper}>
        <p css={modalTitle} id="teacher-gh-report-modal-title">
          Report content
        </p>
        <TextArea
          isRequired
          label="Describe the problem you are experiencing. Your feedback helps us improve results."
          placeholder="Start typing..."
          rows={20}
          value={problemDescription}
          onChange={handleTextAreaChange}
          defaultHeight={144}
          __cssFor={textAreaCss}
        />
        <div css={modalFooterCss}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <div css={footerButtonsWrapper}>
              <ButtonWithTrackEvent
                __cssFor={{ root: ButtonCss }}
                flavor={Button.flavors.secondary}
                objectType={objectTypes.report}
                actionName={actionNames.reject}
                onClick={dismissModal}
                dataProps={{
                  "data-qa-selector": "dismiss-gh-report-modal-button",
                }}
              >
                Cancel
              </ButtonWithTrackEvent>
              <ButtonWithTrackEvent
                __cssFor={{ root: ButtonCss }}
                flavor={Button.flavors.primary}
                objectType={objectTypes.report}
                actionName={actionNames.add}
                onClick={handleSubmitButton}
                dataProps={{
                  "data-qa-selector": "submit-gh-report-modal-button",
                }}
              >
                Submit and remove
              </ButtonWithTrackEvent>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default GuidedHighlightingTeacherFeedbackModal;
